// @ts-nocheck
import { useState } from "react";
import { PostCard } from "@/components/post/PostCard";
import { EmptyState } from "@/components/ui/EmptyState";
import type { Post } from "@/types";

interface BookmarksClientProps { bookmarks: Array<{ created_at: string; posts: Post }>; }

export function BookmarksClient({ bookmarks }: BookmarksClientProps) {
  const [items, setItems] = useState(bookmarks);

  if (!items.length) {
    return <EmptyState title="No bookmarks yet" description="Save posts you want to read later by clicking the bookmark icon." icon="bookmark" />;
  }

  return (
    <div className="space-y-3">
      {items.map(b => <PostCard key={b.posts.id} post={b.posts} userId={null} />)}
    </div>
  );
}
